/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import { t } from 'javascripts/utils/withTranslation';
import type { BurgerProps } from '../types';
import Back from './Back';
import Headline from '../../../atoms/headline/react/Headline';

const BurgerContentMinistry = ({
  setStepKey,
  ministries,
  ministryDropdownName,
}: BurgerProps): React$MixedElement => {
  return (
    <div className="burger__content burger__content--sub">
      <div className="burger__inner">
        <Back setStepKey={setStepKey} />

        <div className="burger__headline">
          <Headline level={2} size={6} id="ministry-headline">
            {ministryDropdownName || t('Alle Ministerien')}
          </Headline>
        </div>

        <nav aria-labelledby="ministry-headline" className="burger__nav">
          <ul className="burger__list">
            {ministries?.map((ministry) => (
              <li key={ministry.modifier} className="burger__list-item">
                <a
                  href={ministry.link}
                  className="burger__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="burger__link-text">{ministry.text}</span>
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default BurgerContentMinistry;
